/* WAIN99 オリジナルラベル受付（sections/wain99-label-order.liquid とセット）
 * 正面ラベルのイメージを canvas で作り、contact フォームで送る。
 * 画像の受け取り：受付用バリアントIDが空のとき（2026-09-26 以降の既定）は「メール方式」。
 *   送信の前にデザイン画像を画面に出して保存してもらい、「保存しました」の確認が取れてから送信する。
 *   作れなかったとき（toBlob 失敗・15秒超過）は送信しない。送信後は受付番号を件名に入れてメールで送ってもらう。
 *   購入できる商品を使わないので、0円注文の経路が生まれない（Codex 査読 P1-01・メール方式査読 P1-01 への対応）。
 * バリアントIDが入っているとき（旧方式）は、システム商品経由で Shopify に上げる。
 */
(function () {
  'use strict';

  var TXT = window.W99_LABEL_TEXT || {};
  var TOOLS = window.W99LabelTools;
  if (!TOOLS) { return; }
  var MAX_BYTES = 20 * 1024 * 1024;
  var LOWRES = 1500;
  var RKEY = 'wain99_label_receipt';
  var SKEY = 'wain99_label_design';
  var SHAPES = { tall: [900, 1200], square: [1080, 1080] };
  var EXPORT_SCALE = 2; /* 仕上がりイメージは画面の2倍の解像度で書き出す */

  function $(root, sel) { return root.querySelector(sel); }
  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function init(root) {
    var canvas = $(root, '[data-lb-canvas]');
    if (!canvas) { return; }
    var ctx = canvas.getContext('2d');
    var st = {
      file: null, img: null, iw: 0, ih: 0,
      shape: 'tall', zoom: 1, rot: 0, ox: 0, oy: 0,
      bg: '#f4efe4', text1: '', text2: '', font: 'Noto Serif JP', pos: 'bottom', color: '#203d34', direction: 'horizontal', language: 'auto', cutout: 'keep', tolerance: 28
    };
    var bottleCanvas = $(root, '[data-lb-bottle]');
    var glass = 'green';
    var GLASS_KEYS = ['green', 'amber', 'black', 'clear'];
    var warn = $(root, '[data-lb-warn]');
    var empty = $(root, '[data-lb-empty]');
    var change = $(root, '[data-lb-change]');
    var zoomEl = $(root, '[data-lb-zoom]');

    var locale = document.documentElement.lang || 'en';
    var ui = {
      ja: { imageBackground:'画像の背景', keepBackground:'背景を残す（元画像に戻す）', removeBackground:'単色の背景を消す', tolerance:'背景を消す強さ', cutoutNote:'画像の端につながる単色の背景向けです。複雑な風景や細い髪は残ることがあります。端末内で処理し、「背景を残す」で元に戻せます。', processing:'背景を処理しています…', processed:'背景を除去しました。仕上がりを確認し、必要なら強さを調整してください。', imageError:'背景を処理できませんでした。元画像に戻しました。', direction:'文字の方向', horizontal:'横書き', vertical:'縦書き（右から左の列）', textLanguage:'文字の言語・字形', automatic:'自動', otherLanguage:'その他の言語', fontNote:'50書体。書体にない文字は多言語対応の書体で補います。縦書きの欧文・アラビア文字は単語の形を保って横向きに配置します。', fontLoading:'書体を読み込んでいます…', fontError:'書体を読み込めませんでした。通信を確認し、書体を選び直してください。保存は読み込み完了後に行えます。' },
      'zh-TW': { imageBackground:'圖片背景', keepBackground:'保留背景（還原原圖）', removeBackground:'移除單色背景', tolerance:'移除強度', cutoutNote:'適用於與圖片邊緣相連的單色背景。複雜場景和細髮可能保留。只在您的裝置上處理；選擇保留背景可還原。', processing:'正在處理背景…', processed:'已移除背景。請確認效果，必要時調整強度。', imageError:'無法處理背景，已還原原圖。', direction:'文字方向', horizontal:'橫書', vertical:'直書（由右至左分欄）', textLanguage:'文字語言與字形', automatic:'自動', otherLanguage:'其他語言', fontNote:'50種字體。字體不包含的文字會以多語字體補足。直書中的西文及阿拉伯文會整詞旋轉，保留字形。', fontLoading:'正在載入字體…', fontError:'無法載入字體。請確認連線並重新選擇字體；載入完成後才能儲存。' },
      'zh-CN': { imageBackground:'图片背景', keepBackground:'保留背景（还原原图）', removeBackground:'移除单色背景', tolerance:'移除强度', cutoutNote:'适用于与图片边缘相连的单色背景。复杂场景和细发可能保留。只在您的设备上处理；选择保留背景可还原。', processing:'正在处理背景…', processed:'已移除背景。请确认效果，必要时调整强度。', imageError:'无法处理背景，已还原原图。', direction:'文字方向', horizontal:'横排', vertical:'竖排（从右向左分栏）', textLanguage:'文字语言与字形', automatic:'自动', otherLanguage:'其他语言', fontNote:'50种字体。字体不包含的文字会以多语言字体补足。竖排中的西文及阿拉伯文会整词旋转，保留字形。', fontLoading:'正在载入字体…', fontError:'无法载入字体。请检查网络并重新选择字体；载入完成后才能保存。' },
      fr: { imageBackground:'Arrière-plan de l’image', keepBackground:'Garder l’arrière-plan (image d’origine)', removeBackground:'Supprimer un arrière-plan uni', tolerance:'Intensité de la suppression', cutoutNote:'Pour un arrière-plan uni qui touche les bords de l’image. Les scènes complexes et les cheveux fins peuvent rester. Le traitement se fait sur votre appareil ; choisissez « Garder l’arrière-plan » pour revenir à l’image d’origine.', processing:'Traitement de l’arrière-plan…', processed:'Arrière-plan supprimé. Vérifiez le résultat et ajustez l’intensité si besoin.', imageError:'Impossible de traiter l’arrière-plan. L’image d’origine a été rétablie.', direction:'Sens d’écriture', horizontal:'Horizontal', vertical:'Vertical (colonnes de droite à gauche)', textLanguage:'Langue et style des caractères', automatic:'Automatique', otherLanguage:'Autres langues', fontNote:'50 polices. Les caractères absents d’une police sont complétés par une police multilingue. En vertical, le texte latin et arabe est tourné mot par mot pour garder sa forme.', fontLoading:'Chargement de la police…', fontError:'Impossible de charger la police. Vérifiez votre connexion et choisissez de nouveau une police. L’enregistrement est possible une fois le chargement terminé.' },
      de: { imageBackground:'Bildhintergrund', keepBackground:'Hintergrund behalten (Original wiederherstellen)', removeBackground:'Einfarbigen Hintergrund entfernen', tolerance:'Stärke der Hintergrundentfernung', cutoutNote:'Für einen einfarbigen Hintergrund, der an die Bildränder grenzt. Komplexe Motive und feine Haare können bleiben. Die Verarbeitung erfolgt auf Ihrem Gerät; mit „Hintergrund behalten“ stellen Sie das Original wieder her.', processing:'Hintergrund wird verarbeitet…', processed:'Hintergrund entfernt. Prüfen Sie das Ergebnis und passen Sie bei Bedarf die Stärke an.', imageError:'Der Hintergrund konnte nicht verarbeitet werden. Das Originalbild wurde wiederhergestellt.', direction:'Schreibrichtung', horizontal:'Horizontal', vertical:'Vertikal (Spalten von rechts nach links)', textLanguage:'Sprache und Schriftform', automatic:'Automatisch', otherLanguage:'Andere Sprachen', fontNote:'50 Schriften. Zeichen, die eine Schrift nicht enthält, werden mit einer mehrsprachigen Schrift ergänzt. Lateinischer und arabischer Text wird in vertikaler Schrift wortweise gedreht, damit die Form erhalten bleibt.', fontLoading:'Schrift wird geladen…', fontError:'Die Schrift konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und wählen Sie die Schrift erneut aus. Speichern ist nach dem Laden möglich.' },
      it: { imageBackground:'Sfondo dell’immagine', keepBackground:'Mantieni lo sfondo (immagine originale)', removeBackground:'Rimuovi lo sfondo a tinta unita', tolerance:'Intensità della rimozione', cutoutNote:'Per uno sfondo a tinta unita che tocca i bordi dell’immagine. Scene complesse e capelli sottili possono restare. L’elaborazione avviene sul tuo dispositivo; scegli «Mantieni lo sfondo» per tornare all’originale.', processing:'Elaborazione dello sfondo…', processed:'Sfondo rimosso. Controlla il risultato e regola l’intensità se serve.', imageError:'Impossibile elaborare lo sfondo. È stata ripristinata l’immagine originale.', direction:'Direzione del testo', horizontal:'Orizzontale', vertical:'Verticale (colonne da destra a sinistra)', textLanguage:'Lingua e stile dei caratteri', automatic:'Automatico', otherLanguage:'Altre lingue', fontNote:'50 font. I caratteri non presenti in un font vengono completati con un font multilingue. In verticale, il testo latino e arabo viene ruotato parola per parola per mantenerne la forma.', fontLoading:'Caricamento del font…', fontError:'Impossibile caricare il font. Controlla la connessione e scegli di nuovo il font. Potrai salvare al termine del caricamento.' },
      es: { imageBackground:'Fondo de la imagen', keepBackground:'Mantener el fondo (imagen original)', removeBackground:'Quitar fondo de un solo color', tolerance:'Intensidad de eliminación', cutoutNote:'Para un fondo de un solo color que toca los bordes de la imagen. Las escenas complejas y el cabello fino pueden quedar. El proceso se hace en tu dispositivo; elige «Mantener el fondo» para volver a la imagen original.', processing:'Procesando el fondo…', processed:'Fondo eliminado. Revisa el resultado y ajusta la intensidad si hace falta.', imageError:'No se pudo procesar el fondo. Se ha restaurado la imagen original.', direction:'Dirección del texto', horizontal:'Horizontal', vertical:'Vertical (columnas de derecha a izquierda)', textLanguage:'Idioma y estilo de los caracteres', automatic:'Automático', otherLanguage:'Otros idiomas', fontNote:'50 tipografías. Los caracteres que no incluye una tipografía se completan con una tipografía multilingüe. En vertical, el texto latino y árabe se gira por palabras para conservar su forma.', fontLoading:'Cargando la tipografía…', fontError:'No se pudo cargar la tipografía. Revisa la conexión y vuelve a elegirla. Podrás guardar cuando termine la carga.' },
      nl: { imageBackground:'Achtergrond van de afbeelding', keepBackground:'Achtergrond behouden (origineel terugzetten)', removeBackground:'Effen achtergrond verwijderen', tolerance:'Sterkte van het verwijderen', cutoutNote:'Voor een effen achtergrond die de randen van de afbeelding raakt. Complexe beelden en fijn haar kunnen blijven staan. De verwerking gebeurt op je apparaat; kies ‘Achtergrond behouden’ om het origineel terug te zetten.', processing:'Achtergrond wordt verwerkt…', processed:'Achtergrond verwijderd. Controleer het resultaat en pas zo nodig de sterkte aan.', imageError:'De achtergrond kon niet worden verwerkt. De originele afbeelding is teruggezet.', direction:'Schrijfrichting', horizontal:'Horizontaal', vertical:'Verticaal (kolommen van rechts naar links)', textLanguage:'Taal en tekenstijl', automatic:'Automatisch', otherLanguage:'Andere talen', fontNote:'50 lettertypen. Tekens die niet in een lettertype zitten, worden aangevuld met een meertalig lettertype. Bij verticale tekst worden Latijnse en Arabische woorden gedraaid, zodat hun vorm behouden blijft.', fontLoading:'Lettertype wordt geladen…', fontError:'Het lettertype kon niet worden geladen. Controleer je verbinding en kies het lettertype opnieuw. Opslaan kan zodra het laden klaar is.' },
      ko: { imageBackground:'이미지 배경', keepBackground:'배경 유지(원본으로 되돌리기)', removeBackground:'단색 배경 지우기', tolerance:'지우는 강도', cutoutNote:'이미지 가장자리에 이어진 단색 배경에 맞는 기능이에요. 복잡한 풍경이나 가는 머리카락은 남을 수 있어요. 처리는 기기 안에서만 하며, ‘배경 유지’를 고르면 원본으로 돌아가요.', processing:'배경을 처리하는 중…', processed:'배경을 지웠어요. 결과를 확인하고 필요하면 강도를 조절해 주세요.', imageError:'배경을 처리하지 못해 원본 이미지로 되돌렸어요.', direction:'글자 방향', horizontal:'가로쓰기', vertical:'세로쓰기(오른쪽 열부터 왼쪽으로)', textLanguage:'글자 언어·자형', automatic:'자동', otherLanguage:'기타 언어', fontNote:'50가지 글꼴. 글꼴에 없는 글자는 다국어 글꼴로 채워요. 세로쓰기의 라틴 문자와 아랍 문자는 단어 모양을 살려 눕혀서 배치해요.', fontLoading:'글꼴을 불러오는 중…', fontError:'글꼴을 불러오지 못했어요. 연결을 확인하고 글꼴을 다시 골라 주세요. 저장은 불러오기가 끝난 뒤에 할 수 있어요.' },
      en: { imageBackground:'Image background', keepBackground:'Keep background (restore original)', removeBackground:'Remove plain background', tolerance:'Removal strength', cutoutNote:'For a plain background connected to the image edges. Complex scenes and fine hair may remain. Processing stays on your device; choose Keep background to restore the original.', processing:'Processing background…', processed:'Background removed. Check the result and adjust the strength if needed.', imageError:'Background processing failed. The original image has been restored.', direction:'Writing direction', horizontal:'Horizontal', vertical:'Vertical (columns right to left)', textLanguage:'Character language / style', automatic:'Automatic', otherLanguage:'Other languages', fontNote:'50 fonts. Characters outside a font’s coverage use a multilingual font. Vertical Latin and Arabic text is rotated as words to preserve its shape.', fontLoading:'Loading font…', fontError:'Could not load the font. Check your connection and select a font again. Saving is available after loading completes.' }
    };
    ui = ui[locale] || (/^zh-(Hant|HK)/i.test(locale) ? ui['zh-TW'] : /^zh/i.test(locale) ? ui['zh-CN'] : ui.en);
    $all(root, '[data-lb-i18n]').forEach(function(el) { el.textContent = ui[el.getAttribute('data-lb-i18n')] || el.textContent; });
    var fontSelect = $(root, '[data-lb-font]');
    fontSelect.textContent = '';
    TOOLS.fonts.forEach(function(f) { var o = document.createElement('option'); o.value=f[0]; o.textContent=f[1]; fontSelect.appendChild(o); });
    var fontStatus = $(root, '[data-lb-font-status]');
    var originalImg = null, imageSeq = 0, imageReady = Promise.resolve(), fontReadyKey = '', fontPromiseKey = '', fontPromise = null;
    var fontTimer = null, renderSequence = 0;
    function textLanguage() { return st.language !== 'auto' ? st.language : (/^zh-(TW|HK|Hant)/i.test(locale) ? 'zh-Hant' : /^zh/i.test(locale) ? 'zh-Hans' : 'ja'); }
    function fontText() { var t = st.text1 + ' ' + st.text2; return st.direction === 'vertical' ? t + TOOLS.verticalRuns(t).map(function(r) { return r.text; }).join('') : t; }
    function fontNames() { return [st.font].concat(TOOLS.fallbackFamilies(fontText(), textLanguage())).filter(function(f,i,a) { return a.indexOf(f) === i; }); }
    function fontKey() { return [st.font, textLanguage(), fontText()].join('|'); }
    function ensureFonts() {
      var key=fontKey(), sample=fontText();
      if (!sample.trim()) { fontReadyKey=key; return Promise.resolve(); }
      if (fontReadyKey===key) { return Promise.resolve(); }
      if (fontPromiseKey===key && fontPromise) { return fontPromise; }
      fontStatus.textContent=ui.fontLoading;
      fontPromiseKey=key;
      var loading = withTimeout(Promise.all(fontNames().map(function(f) { return TOOLS.loadFamily(f, sample); })), 14000).then(function() {
        if (key===fontKey()) { fontReadyKey=key; fontStatus.textContent=''; }
      }).catch(function(err) { if(key===fontKey()){fontStatus.textContent=ui.fontError;} throw err; });
      fontPromise=loading;
      loading.then(function(){if(fontPromise===loading){fontPromise=null;}},function(){if(fontPromise===loading){fontPromise=null;}});
      return loading;
    }
    function showWarn(msg) { warn.textContent = msg || ''; warn.hidden = !msg; }

    /* ---------- 描画 ---------- */
    function coverScale(W, H) {
      if (!st.img) { return 1; }
      var sw = st.rot % 180 ? st.ih : st.iw;
      var sh = st.rot % 180 ? st.iw : st.ih;
      return Math.max(W / sw, H / sh);
    }
    function fitScale(W, H) {
      var sw = st.rot % 180 ? st.ih : st.iw;
      var sh = st.rot % 180 ? st.iw : st.ih;
      return Math.min(W / sw, H / sh);
    }
    function fontFamily() { return fontNames().map(function(f) { return '"'+f+'"'; }).join(',') + ',"Apple Color Emoji","Segoe UI Emoji",sans-serif'; }
    function drawText(c, W, H) {
      var lines = [{text:st.text1.trim(),size:W*0.085,weight:600},{text:st.text2.trim(),size:W*0.05,weight:400}].filter(function(t){return t.text;});
      if (!lines.length || fontReadyKey !== fontKey()) { return; }
      c.save(); c.fillStyle=st.color; c.textAlign='center'; c.textBaseline='middle';
      if(st.direction==='vertical') {
        var gap=W*0.13;
        lines.forEach(function(line,index){
          var runs=TOOLS.verticalRuns(line.text), size=line.size;
          c.font=line.weight+' '+size+'px '+fontFamily();
          var heights=runs.map(function(run){return run.upright ? size*1.15 : Math.max(size,c.measureText(run.text).width);});
          var total=heights.reduce(function(a,b){return a+b;},0), factor=Math.min(1,H*0.78/total);
          size*=factor; total*=factor;
          var x=W/2+(lines.length-1)*gap/2-index*gap, y=st.pos==='top'?H*0.1:H*0.9-total;
          c.font=line.weight+' '+size+'px '+fontFamily();
          runs.forEach(function(run,i){var h=heights[i]*factor;c.save();c.translate(x,y+h/2);c.direction=/[\u0590-\u08ff]/.test(run.text)?'rtl':'ltr';if(!run.upright){c.rotate(Math.PI/2);}c.fillText(run.text,0,0);c.restore();y+=h;});
        });
      } else {
        var y=st.pos==='top'?H*0.12:H*(lines.length>1?0.8:0.86);
        lines.forEach(function(line){c.font=line.weight+' '+Math.round(line.size)+'px '+fontFamily();c.direction=/[\u0590-\u08ff]/.test(line.text)?'rtl':'ltr';c.fillText(line.text,W/2,y,W*0.86);y+=W*0.1;});
      }
      c.restore();
    }
    function draw(c, W, H, guide) {
      c.save();
      c.fillStyle = st.bg;
      c.fillRect(0, 0, W, H);
      if (st.img) {
        var s = coverScale(W, H) * st.zoom;
        c.translate(W / 2 + st.ox * W, H / 2 + st.oy * H);
        c.rotate(st.rot * Math.PI / 180);
        c.drawImage(st.img, -st.iw * s / 2, -st.ih * s / 2, st.iw * s, st.ih * s);
        c.setTransform(1, 0, 0, 1, 0, 0);
      }
      c.restore();
      drawText(c, W, H);
      if (guide) {
        c.save();
        c.strokeStyle = 'rgba(0,0,0,.45)';
        c.setLineDash([W * 0.012, W * 0.012]);
        c.lineWidth = Math.max(1, W * 0.0025);
        var m = W * 0.04;
        c.strokeRect(m, m, W - m * 2, H - m * 2);
        c.restore();
      }
    }
    var bottleTimer = null;
    function paint() {
      var d = SHAPES[st.shape];
      if (canvas.width !== d[0] || canvas.height !== d[1]) { canvas.width = d[0]; canvas.height = d[1]; }
      draw(ctx, canvas.width, canvas.height, true);
      var hasDesign = !!(st.img || st.text1.trim() || st.text2.trim());
      empty.hidden = hasDesign;
      if (change) { change.hidden = !hasDesign; }
      clearTimeout(bottleTimer);
      bottleTimer = setTimeout(updateBottle, 60);
      saveDesign();
    }
    function render() {
      var seq=++renderSequence;
      paint();
      clearTimeout(fontTimer);
      fontTimer=setTimeout(function(){ensureFonts().then(function(){if(seq===renderSequence){paint();}}).catch(function(){});},120);
    }
    function processBackground() {
      var seq=++imageSeq, mode=$(root,'[data-lb-cutout]'), options=$(root,'[data-lb-cutout-options]'), status=$(root,'[data-lb-image-status]');
      st.cutout=mode.value; st.tolerance=Number($(root,'[data-lb-tolerance]').value);
      options.hidden=st.cutout!=='remove';
      if(!originalImg || st.cutout==='keep'){st.img=originalImg;status.textContent='';imageReady=Promise.resolve();render();return;}
      status.textContent=ui.processing;
      var off=document.createElement('canvas'), scale=Math.min(1,2048/Math.max(st.iw,st.ih));
      off.width=Math.max(1,Math.round(st.iw*scale));off.height=Math.max(1,Math.round(st.ih*scale));
      var c=off.getContext('2d',{willReadFrequently:true});c.drawImage(originalImg,0,0,off.width,off.height);
      imageReady=TOOLS.removeBorder(c.getImageData(0,0,off.width,off.height),off.width,off.height,st.tolerance,function(){return seq!==imageSeq;}).then(function(data){
        if(seq!==imageSeq){return;}c.putImageData(data,0,0);st.img=off;status.textContent=ui.processed;render();
      }).catch(function(){if(seq===imageSeq){st.img=originalImg;st.cutout='keep';mode.value='keep';options.hidden=true;status.textContent=ui.imageError;render();}});
    }
    $(root,'[data-lb-cutout]').addEventListener('change',processBackground);
    $(root,'[data-lb-tolerance]').addEventListener('change',processBackground);
    /* ---------- 瓶に貼ったイメージ（Codex 制作の3Dレンダー写真＋円柱に巻いたラベル＋ラベル範囲だけの陰り・光沢）
       素材と数値は (A Codex)/2026-09-26/original-label-bottle/（bottle.json）。
       x = 520 + R*sin(thetaMax*(2u-1))、R=260、thetaMax=asin(210/260)。上下の弧は0（正面の平行投影）。 */
    var BOTTLE = window.W99_BOTTLE || {};
    var BJ = { R: 260, cx: 520, thetaMax: Math.asin(210 / 260),
      rect: { tall: { x: 310, y: 1160, w: 420, h: 560 }, square: { x: 310, y: 1230, w: 420, h: 420 } } };
    // Profiles are explicit product mappings; never infer bottle geometry from volume or title.
    var profileSelect = $(root, '[data-lb-profile]');
    var profileNote = $(root, '[data-lb-profile-note]');
    var profileStatus = $(root, '[data-lb-profile-status]');
    var profileID = '';
    var profiles = [];
    var profileData = document.getElementById(root.getAttribute('data-profiles-id'));
    try { profiles = JSON.parse(profileData ? profileData.textContent : '[]'); } catch (e) {}
    if (!Array.isArray(profiles)) { profiles = []; }
    profiles = profiles.filter(function (p) {
      return p && typeof p.id === 'string' && typeof p.title === 'string' && typeof p.image === 'string' &&
        /^(https?:)?\//.test(p.image) && Number.isFinite(p.bodyWidth) && Number.isFinite(p.labelWidth) &&
        Number.isFinite(p.labelY) && p.bodyWidth >= 10 && p.bodyWidth <= 90 &&
        p.labelWidth >= 10 && p.labelWidth < p.bodyWidth && p.labelY >= 25 && p.labelY <= 85;
    });
    profiles.forEach(function (p) {
      if (!profileSelect) { return; }
      var o = document.createElement('option'); o.value = p.id; o.textContent = p.title;
      profileSelect.appendChild(o);
    });
    function activeProfile() { return profiles.find(function (p) { return p.id === profileID; }) || null; }
    var profileLabel = profileSelect ? profileSelect.closest('.w99-lb__profile-label') : null;
    if (profileLabel) { profileLabel.hidden = profiles.length === 0; }
    function profileUI() {
      var p = activeProfile();
      if (profileSelect) { profileSelect.value = p ? p.id : ''; }
      var colors = $(root, '.w99-lb__glass'); if (colors) { colors.hidden = !!p; }
      if (profileNote) { profileNote.textContent = profileNote.getAttribute(p ? 'data-specific' : 'data-general'); }
      if (profileStatus) { profileStatus.hidden = true; }
    }
    if (profileSelect) { profileSelect.addEventListener('change', function () {
      profileID = profileSelect.value; profileUI(); updateBottle(); saveDesign();
    }); }
    var imgCache = {};
    function loadImg(url) {
      if (!url) { return Promise.reject(new Error('no url')); }
      if (!imgCache[url]) {
        imgCache[url] = new Promise(function (res, rej) {
          var im = new Image(); im.crossOrigin = 'anonymous';
          im.onload = function () { res(im); }; im.onerror = function (e) { delete imgCache[url]; rej(e); }; im.src = url;
        });
      }
      return imgCache[url];
    }
    var bottleSeq = 0;
    function updateBottle() {
      if (!bottleCanvas) { return; }
      var seq = ++bottleSeq;
      var profile = activeProfile();
      var loading = profile ? [loadImg(profile.image)] : [loadImg(BOTTLE[glass] || BOTTLE.green), loadImg(BOTTLE.shade), loadImg(BOTTLE.highlight)];
      Promise.all(loading).then(function (im) {
        if (seq !== bottleSeq) { return; }
        var W = profile ? 1000 : 1040, H = profile ? 2000 : 2200;
        if (bottleCanvas.width !== W) { bottleCanvas.width = W; bottleCanvas.height = H; }
        var c = bottleCanvas.getContext('2d');
        c.globalCompositeOperation = 'source-over';
        c.clearRect(0, 0, W, H);
        if (profile) {
          // Images are square; show their central half without stretching the bottle.
          var cropW = im[0].naturalHeight / 2;
          if (cropW > im[0].naturalWidth) { throw new Error('image aspect'); }
          c.drawImage(im[0], (im[0].naturalWidth - cropW) / 2, 0, cropW, im[0].naturalHeight, 0, 0, W, H);
        } else { c.drawImage(im[0], 0, 0, W, H); }
        /* ラベルを円柱に巻く（列ごとに逆写像で元の位置を引く） */
        var d = SHAPES[st.shape], r = BJ.rect[st.shape] || BJ.rect.tall;
        var radius = BJ.R, center = BJ.cx, angle = BJ.thetaMax;
        if (profile) {
          var width = W * profile.labelWidth / 100;
          var height = width * d[1] / d[0];
          radius = W * profile.bodyWidth / 200; center = W / 2;
          angle = Math.asin(width / (2 * radius));
          r = { x: (W - width) / 2, y: H * profile.labelY / 100 - height / 2, w: width, h: height };
          if (r.y < 0 || r.y + r.h > H) { throw new Error('label outside image'); }
        }
        var src = document.createElement('canvas');
        src.width = d[0]; src.height = d[1];
        draw(src.getContext('2d'), src.width, src.height, false);
        var L = document.createElement('canvas'); L.width = W; L.height = H;
        var lc = L.getContext('2d');
        for (var x = r.x; x < r.x + r.w; x++) {
          var s = (x + 0.5 - center) / radius;
          if (s <= -1 || s >= 1) { continue; }
          var u = (Math.asin(s) / angle + 1) / 2;
          if (u < 0 || u > 1) { continue; }
          var u2 = (Math.asin(Math.min(0.9999, (x + 1.5 - center) / radius)) / angle + 1) / 2;
          var sx = u * src.width, sw = Math.max(1, (u2 - u) * src.width);
          lc.drawImage(src, Math.min(src.width - 1, sx), 0, Math.min(sw, src.width - sx), src.height, x, r.y, 1.02, r.h);
        }
        c.drawImage(L, 0, 0);
        /* 陰り（乗算）と光沢（スクリーン）はラベルの範囲だけに重ねる */
        function masked(img) {
          var o = document.createElement('canvas'); o.width = W; o.height = H;
          var oc = o.getContext('2d'); oc.drawImage(img, 0, 0, W, H);
          oc.globalCompositeOperation = 'destination-in'; oc.drawImage(L, 0, 0);
          return o;
        }
        if (profile) {
          // Procedural shading is clipped to the label; do not reuse another bottle's overlay.
          var shade = document.createElement('canvas'); shade.width = W; shade.height = H;
          var sc = shade.getContext('2d'), g = sc.createLinearGradient(r.x, 0, r.x + r.w, 0);
          g.addColorStop(0, 'rgba(0,0,0,.22)'); g.addColorStop(.3, 'rgba(0,0,0,0)');
          g.addColorStop(.65, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,.24)');
          sc.fillStyle = g; sc.fillRect(r.x, r.y, r.w, r.h);
          c.globalCompositeOperation = 'multiply'; c.drawImage(masked(shade), 0, 0);
        } else {
          c.globalCompositeOperation = 'multiply'; c.drawImage(masked(im[1]), 0, 0);
          c.globalCompositeOperation = 'screen'; c.drawImage(masked(im[2]), 0, 0);
        }
        c.globalCompositeOperation = 'source-over';
      }).catch(function () {
        if (seq !== bottleSeq) { return; }
        bottleCanvas.getContext('2d').clearRect(0, 0, bottleCanvas.width, bottleCanvas.height);
        if (profileStatus) { profileStatus.textContent = profileStatus.getAttribute('data-image-error'); profileStatus.hidden = false; }
      });
    }
    $all(root, '[data-lb-glass]').forEach(function (b) {
      b.addEventListener('click', function () {
        glass = b.getAttribute('data-lb-glass');
        $all(root, '[data-lb-glass]').forEach(function (o) { o.classList.toggle('is-on', o === b); o.setAttribute('aria-pressed', String(o === b)); });
        updateBottle(); saveDesign();
      });
    });

    /* ---------- 画像の読み込み ---------- */
    function loadFile(file) {
      showWarn('');
      if (!file) { return; }
      if (!/^image\/(jpeg|png|webp)$/.test(file.type)) { showWarn(TXT.badtype); return; }
      if (file.size > MAX_BYTES) { showWarn(TXT.toobig); return; }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        originalImg = img;
        st.file = file; st.img = img; st.iw = img.naturalWidth; st.ih = img.naturalHeight;
        st.zoom = 1; st.rot = 0; st.ox = 0; st.oy = 0;
        zoomEl.value = 100;
        if (Math.min(st.iw, st.ih) < LOWRES) { showWarn(TXT.lowres); }
        var ni = $(root, '[data-lb-noimage]');
        if (ni) { ni.checked = false; }
        processBackground();
      };
      img.onerror = function () { URL.revokeObjectURL(url); showWarn(TXT.badtype); };
      img.src = url;
    }
    $all(root, '[data-lb-file]').forEach(function (inp) {
      inp.addEventListener('change', function () { loadFile(inp.files && inp.files[0]); inp.value = ''; });
    });
    var drop = $(root, '[data-lb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      loadFile(f);
    });

    /* ---------- ドラッグで移動 ---------- */
    var dragging = null;
    canvas.addEventListener('pointerdown', function (e) {
      if (!st.img) { return; }
      dragging = { x: e.clientX, y: e.clientY, ox: st.ox, oy: st.oy };
      canvas.setPointerCapture(e.pointerId);
      canvas.classList.add('is-dragging');
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!dragging) { return; }
      var r = canvas.getBoundingClientRect();
      st.ox = dragging.ox + (e.clientX - dragging.x) / r.width;
      st.oy = dragging.oy + (e.clientY - dragging.y) / r.height;
      render();
    });
    function endDrag() { dragging = null; canvas.classList.remove('is-dragging'); }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);

    /* ---------- 操作 ---------- */
    zoomEl.addEventListener('input', function () { st.zoom = zoomEl.value / 100; render(); });
    $(root, '[data-lb-fit]').addEventListener('click', function () {
      if (!st.img) { return; }
      var d = SHAPES[st.shape];
      st.zoom = fitScale(d[0], d[1]) / coverScale(d[0], d[1]);
      st.ox = 0; st.oy = 0; zoomEl.value = Math.round(st.zoom * 100); render();
    });
    $(root, '[data-lb-fill]').addEventListener('click', function () {
      st.zoom = 1; st.ox = 0; st.oy = 0; zoomEl.value = 100; render();
    });
    $(root, '[data-lb-rotate]').addEventListener('click', function () { st.rot = (st.rot + 90) % 360; render(); });
    $all(root, '[data-lb-shape]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { st.shape = r.value; render(); } });
    });
    function bindVal(sel, key) {
      var el = $(root, sel);
      if (!el) { return; }
      el.addEventListener('input', function () { st[key] = el.value; render(); });
      el.addEventListener('change', function () { st[key] = el.value; render(); });
    }
    bindVal('[data-lb-bg]', 'bg');
    bindVal('[data-lb-text1]', 'text1');
    bindVal('[data-lb-text2]', 'text2');
    bindVal('[data-lb-font]', 'font');
    bindVal('[data-lb-direction]', 'direction');
    bindVal('[data-lb-language]', 'language');
    bindVal('[data-lb-pos]', 'pos');
    bindVal('[data-lb-color]', 'color');
    $(root, '[data-lb-reset]').addEventListener('click', function () {
      imageSeq += 1; originalImg = null; imageReady=Promise.resolve();
      st.cutout='keep'; $(root,'[data-lb-cutout]').value='keep'; $(root,'[data-lb-cutout-options]').hidden=true; $(root,'[data-lb-image-status]').textContent='';
      st.file = null; st.img = null; st.zoom = 1; st.rot = 0; st.ox = 0; st.oy = 0;
      st.text1 = ''; st.text2 = '';
      zoomEl.value = 100;
      ['[data-lb-text1]', '[data-lb-text2]'].forEach(function (s) { var el = $(root, s); if (el) { el.value = ''; } });
      showWarn('');
      render();
    });

    /* ---------- ログインで画面を離れても文字などの設定は残す（画像は残さない） ---------- */
    function settings() {
      return {
        shape: st.shape, zoom: Math.round(st.zoom * 100) / 100, rotate: st.rot,
        offset: [Math.round(st.ox * 1000) / 1000, Math.round(st.oy * 1000) / 1000],
        background: st.bg, bottle: glass, bottleProfile: profileID, writingDirection: st.direction, textLanguage: st.language, imageBackground: st.cutout, removalStrength: st.tolerance, text1: st.text1, text2: st.text2, font: st.font, textPosition: st.pos, textColor: st.color,
        image: st.file ? { name: st.file.name, width: st.iw, height: st.ih, bytes: st.file.size } : null
      };
    }
    function saveDesign() { try { sessionStorage.setItem(SKEY, JSON.stringify(settings())); } catch (e) {} }
    function restoreDesign() {
      var s = null;
      try { s = JSON.parse(sessionStorage.getItem(SKEY) || 'null'); } catch (e) {}
      if (!s) { return; }
      if (profiles.some(function (p) { return p.id === s.bottleProfile; })) { profileID = s.bottleProfile; }
      st.shape = SHAPES[s.shape] ? s.shape : 'tall';
      st.bg = s.background || st.bg; st.text1 = s.text1 || ''; st.text2 = s.text2 || '';
      st.font = s.font === 'serif' ? 'Noto Serif JP' : s.font === 'sans' ? 'Noto Sans JP' : (TOOLS.fonts.some(function(f){return f[0]===s.font;}) ? s.font : 'Noto Serif JP');
      st.direction=s.writingDirection==='vertical'?'vertical':'horizontal'; st.language=['auto','ja','zh-Hant','zh-Hans','other'].indexOf(s.textLanguage)>=0?s.textLanguage:'auto'; st.pos = s.textPosition || 'bottom'; st.color = s.textColor || st.color;
      if (s.bottle && GLASS_KEYS.indexOf(s.bottle) >= 0) {
        glass = s.bottle;
        $all(root, '[data-lb-glass]').forEach(function (o) { var on = o.getAttribute('data-lb-glass') === glass; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', String(on)); });
      }
      $all(root, '[data-lb-shape]').forEach(function (r) { r.checked = r.value === st.shape; });
      var map = { '[data-lb-bg]': st.bg, '[data-lb-text1]': st.text1, '[data-lb-text2]': st.text2, '[data-lb-font]': st.font, '[data-lb-direction]': st.direction, '[data-lb-language]': st.language, '[data-lb-pos]': st.pos, '[data-lb-color]': st.color };
      Object.keys(map).forEach(function (k) { var el = $(root, k); if (el) { el.value = map[k]; } });
    }

    /* ---------- 送信 ---------- */
    function makeReceipt() {
      var d = new Date(Date.now() + 8 * 3600 * 1000); /* 台湾時間 */
      var ymd = String(d.getUTCFullYear()).slice(2) + ('0' + (d.getUTCMonth() + 1)).slice(-2) + ('0' + d.getUTCDate()).slice(-2);
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
      for (var k = 0; k < 4; k++) { r += chars.charAt(Math.floor(Math.random() * chars.length)); }
      return 'LB' + ymd + '-' + r;
    }
    function exportPreview() {
      var key=fontKey(), imageJob=imageReady;
      return Promise.all([ensureFonts(),imageJob]).then(function(){
        /* The user can edit while pressing Save; never export with stale font/image readiness. */
        if(key!==fontKey() || imageJob!==imageReady){return exportPreview();}
        return new Promise(function(resolve,reject){
          try {var d=SHAPES[st.shape],off=document.createElement('canvas');off.width=d[0]*EXPORT_SCALE;off.height=d[1]*EXPORT_SCALE;
            draw(off.getContext('2d'),off.width,off.height,false);off.toBlob(resolve,'image/jpeg',0.92);
          }catch(err){reject(err);}
        });
      });
    }
    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
    function removeLine(key) {
      return fetch(cartRoot() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (res) {
        if (!res.ok) { throw new Error('change ' + res.status); }
        return res.json();
      }).then(function (cart) {
        if (!Array.isArray(cart.items)) { throw new Error('bad cart'); }
        if (cart.items.some(function (it) { return it.key === key; })) { throw new Error('still in cart'); }
        return cart;
      });
    }
    /* 画像受付用の商品がカートに残っていたら外す（お客様の他の商品には触れない） */
    function cleanupCart() {
      var variant = root.getAttribute('data-upload-variant');
      if (!variant) { return; }
      fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) { throw new Error('cart ' + r.status); } return r.json(); }).then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) { throw new Error('bad cart'); }
        var lines = cart.items.filter(function (it) { return String(it.variant_id) === String(variant); });
        return Promise.all(lines.map(function (it) { return removeLine(it.key); })).then(function () {
          try { sessionStorage.removeItem('wain99_label_cleanup'); } catch (e) {}
        });
      }).catch(function () {});
    }
    /* デザイン画像を端末に保存する（メール方式で添付してもらう） */
    var designDownloadUrl = null, designDownloadLink = null;
    function saveLabel(kind) {
      var translations = {
        preparing: {ja:'画像を準備しています…','zh-TW':'正在準備圖片…','zh-CN':'正在准备图片…',en:'Preparing image…',fr:'Préparation de l’image…',de:'Bild wird vorbereitet…',it:'Preparazione dell’immagine…',es:'Preparando la imagen…',nl:'Afbeelding wordt voorbereid…',ko:'이미지를 준비하는 중…'},
        download: {ja:'画像を保存（自動で保存されない場合）','zh-TW':'儲存圖片（若未自動下載）','zh-CN':'保存图片（如未自动下载）',en:'Save image (if download did not start)',fr:'Enregistrer l’image (si le téléchargement n’a pas démarré)',de:'Bild speichern (falls der Download nicht startet)',it:'Salva l’immagine (se il download non è partito)',es:'Guardar la imagen (si la descarga no empezó)',nl:'Afbeelding opslaan (als de download niet start)',ko:'이미지 저장(자동으로 저장되지 않을 때)'}
      };
      var lang = /^ja/.test(locale)?'ja':/^zh-(TW|HK|Hant)/i.test(locale)?'zh-TW':/^zh/i.test(locale)?'zh-CN':(translations[kind][locale] ? locale : 'en');
      return translations[kind][lang];
    }
    function downloadDesign(filename) {
      return withTimeout(exportPreview(), 20000).then(function (blob) {
        if (!blob) { return false; }
        var previous = designDownloadUrl;
        designDownloadUrl = URL.createObjectURL(blob);
        if (!designDownloadLink) {
          designDownloadLink = document.createElement('a');
          designDownloadLink.className = 'link w99-lb__reset';
          designDownloadLink.setAttribute('data-lb-design-download', '');
          designDownloadLink.rel = 'noopener';
          saveBtn.parentNode.appendChild(designDownloadLink);
        }
        designDownloadLink.href = designDownloadUrl;
        designDownloadLink.download = filename;
        designDownloadLink.textContent = saveLabel('download');
        designDownloadLink.hidden = false;
        /* Keep a real link available if the browser blocks the async automatic download. */
        designDownloadLink.click();
        if (previous) { setTimeout(function () { URL.revokeObjectURL(previous); }, 60000); }
        return true;
      }).catch(function () { return false; });
    }
    var MAILMODE = !root.getAttribute('data-upload-variant');
    var saveBtn = $(root, '[data-lb-save]');
    if (saveBtn) {
      saveBtn.hidden = false;
      saveBtn.addEventListener('click', function () {
        if (!(st.img || st.text1 || st.text2) || saveBtn.disabled) { return; }
        var originalLabel = saveBtn.textContent;
        saveBtn.disabled = true; saveBtn.textContent = saveLabel('preparing');
        if (designDownloadLink) { designDownloadLink.hidden = true; }
        downloadDesign('wain99-label-design.jpg').then(function (ok) {
          saveBtn.disabled = false; saveBtn.textContent = originalLabel;
          if (!ok) { showWarn(TXT.save_fail); }
        });
      });
    }
    function withTimeout(p, ms) {
      return new Promise(function (resolve, reject) {
        var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
        p.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
      });
    }
    /* 直近の受付（受付番号・メール待ち）を3日間だけ端末に残す。再読み込みやメールアプリからの戻りでも案内を出すため */
    var LKEY = 'wain99_label_last', KEEP_MS = 3 * 24 * 3600 * 1000;
    function saveLast(no, mail) { try { localStorage.setItem(LKEY, JSON.stringify({ no: no, mail: !!mail, t: Date.now() })); } catch (e) {} }
    function loadLast() {
      try {
        var v = JSON.parse(localStorage.getItem(LKEY) || 'null');
        if (v && v.no && Date.now() - v.t < KEEP_MS) { return v; }
        localStorage.removeItem(LKEY);
      } catch (e) {}
      return null;
    }
    /* 画像受付用のシステム商品をカートに入れて画像を上げ、返ってきた URL を取ってすぐ外す（旧方式） */
    function uploadImages(receipt) {
      var variant = root.getAttribute('data-upload-variant');
      if (!variant) { return Promise.reject(new Error('no upload variant')); }
      return exportPreview().then(function (blob) {
        var fd = new FormData();
        fd.append('id', variant);
        fd.append('quantity', '1');
        fd.append('properties[_w99_receipt]', receipt);
        fd.append('properties[_w99_label_original]', st.file, st.file.name || 'label-original');
        if (blob) { fd.append('properties[_w99_label_preview]', blob, receipt + '-preview.jpg'); }
        return fetch(cartRoot() + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      }).then(function (res) {
        if (!res.ok) { throw new Error('upload ' + res.status); }
        return res.json();
      }).then(function (item) {
        var p = item.properties || {};
        var urls = { original: p._w99_label_original || '', preview: p._w99_label_preview || '' };
        if (!urls.original) { throw new Error('no url'); }
        return removeLine(item.key).catch(function () { return removeLine(item.key); }).then(function () { return urls; }, function () {
          /* 画像は上がったが外せなかった：送信は続け、次に開いたときに掃除する */
          try { sessionStorage.setItem('wain99_label_cleanup', '1'); } catch (e) {}
          urls.cleanupFailed = true;
          return urls;
        });
      });
    }

    var form = $(root, '[data-lb-form]');
    if (form) {
      var btn = $(form, '[data-lb-submit]');
      var fwarn = $(form, '[data-lb-form-warn]');
      var btnText = btn ? btn.textContent : '';
      var noimg = $(form, '[data-lb-noimage]');
      var snapshot = null, formSnap = null, gen = 0, uploadedKey = null, uploadedUrls = null, guardTimer = null;
      /* 送信のたびに、フォームの入力（出どころ・画像なし等）をその時点の値で固定する */
      function snapForm() {
        return Array.prototype.map.call(form.elements, function (el) { return [el, (el.type === 'checkbox' || el.type === 'radio') ? el.checked : el.value]; });
      }
      function restoreForm(snap) {
        (snap || []).forEach(function (p) { if (p[0].type === 'checkbox' || p[0].type === 'radio') { p[0].checked = p[1]; } else if (p[0].type !== 'hidden') { p[0].value = p[1]; } });
      }
      function lockEditor(on) {
        $all(root, '.w99-lb__editor input, .w99-lb__editor select, .w99-lb__editor button').forEach(function (el) { el.disabled = on; });
        root.classList.toggle('is-busy', on);
      }
      function finish(receipt, urls, note) {
        $(form, '[data-lb-receipt-input]').value = receipt;
        $(form, '[data-lb-url-original]').value = (urls && urls.original) || note || '';
        $(form, '[data-lb-url-preview]').value = (urls && urls.preview) || '';
        restoreForm(formSnap);
        var rec = JSON.parse(JSON.stringify(snapshot || settings())); if (note) { rec.note = note; }
        $(form, '[data-lb-settings]').value = JSON.stringify(rec);
        try { sessionStorage.setItem(RKEY, receipt); } catch (e) {}
        saveDesign();
        /* Shopify の正規 protect API がフォームを保護してから送信する。
           requestSubmit の再発火や prototype.submit は非同期の画像確認と競合する。 */
        var captchaGen = gen;
        lockForm(true);
        if (btn) { btn.disabled = true; btn.textContent = TXT.sending; }
        function captchaFailed() {
          if (captchaGen !== gen) { return; }
          gen += 1;
          reset();
          fwarn.textContent = TXT.captcha_fail || 'Security verification could not finish. Your design is still here. Please try again.';
          fwarn.hidden = false;
        }
        clearTimeout(guardTimer);
        /* protect の準備待ちの上限を3分に（Claude 査読 P2-01）。パズル自体は Shopify の /challenge 画面で行われる */
        guardTimer = setTimeout(captchaFailed, 180000);
        if (!window.Shopify || !window.Shopify.captcha || typeof window.Shopify.captcha.protect !== 'function') {
          /* 呼び出し口が無い＝読み込み失敗か設定不明。迂回せず、入力を残したまま画面内で止めて再試行を案内する（Codex 査読 P1・2026-09-28） */
          captchaFailed();
          return;
        }
        try {
          window.Shopify.captcha.protect(form, function () {
            if (captchaGen !== gen) { return; }
            clearTimeout(guardTimer);
            restoreForm(formSnap);
            lockForm(false);
            if (!form.reportValidity()) { reset(); return; }
            form.setAttribute('data-lb-ready', '1');
            if (btn) { btn.disabled = true; btn.textContent = TXT.sending; }
            /* form.submit は protect により差し替えられ、検証トークンを付けて送信する。 */
            try { form.submit(); } catch (err) { captchaFailed(); }
            /* プロバイダーの通信失敗時も、入力・画像は消さず再試行できるようにする。 */
            if (captchaGen === gen) { guardTimer = setTimeout(captchaFailed, 90000); }
          });
        } catch (err) { captchaFailed(); }
      }
      function reset() { if (btn) { btn.disabled = false; btn.textContent = btnText; } lockEditor(false); lockForm(false); clearTimeout(guardTimer); form.removeAttribute('data-lb-ready'); }
      var og = $(form, '[data-lb-origin]'), od = $(form, '[data-lb-origin-detail]');
      function originKind() { return og && og.selectedOptions[0] ? og.selectedOptions[0].getAttribute('data-k') : ''; }
      function syncOrigin() {
        if (!od) { return; }
        var k = originKind();
        od.required = (k === 'perm' || k === 'stock');
        od.setCustomValidity(od.required && !od.value.trim() ? (TXT.origin_detail_need || '') : '');
      }
      if (og) { og.addEventListener('change', syncOrigin); }
      if (od) { od.addEventListener('input', syncOrigin); }
      if (noimg) { noimg.addEventListener('change', function () { if (noimg.checked && og) { og.value = og.querySelector('[data-k=none]').value; syncOrigin(); } }); }
      var ms = $(form, '[data-lb-mailstep]'), msUrl = null;
      /* 保存確認のあいだは申込フォームの入力も固定する（確認中の訂正・同意の解除が送信で古い値に戻るのを防ぐ。
         訂正したいときは「デザインに戻る」から。メール方式査読 第2回 P1-01） */
      function lockForm(on) {
        Array.prototype.forEach.call(form.elements, function (el) {
          /* セキュリティ用 hidden と CAPTCHA の内部要素はロックしない。 */
          if (el.type === 'hidden' || (ms && ms.contains(el)) || !(el === btn || /^contact\[/.test(el.name || ''))) { return; }
          if (on) { if (!el.disabled) { el.disabled = true; el.setAttribute('data-lb-locked', '1'); } }
          else if (el.getAttribute('data-lb-locked') === '1') { el.disabled = false; el.removeAttribute('data-lb-locked'); }
        });
      }
      function hideMailStep() {
        lockForm(false);
        if (ms) { ms.hidden = true; }
        if (btn) { btn.hidden = false; }
      }
      function showMailStep(receipt, blob, myGen) {
        if (!ms) { gen += 1; reset(); fwarn.textContent = TXT.save_fail; fwarn.hidden = false; return; }
        if (msUrl) { try { URL.revokeObjectURL(msUrl); } catch (e) {} }
        msUrl = URL.createObjectURL(blob);
        var img = $(ms, '[data-lb-ms-img]'), dl = $(ms, '[data-lb-ms-dl]'), ck = $(ms, '[data-lb-ms-check]'), send = $(ms, '[data-lb-ms-send]');
        img.src = msUrl; dl.href = msUrl; dl.setAttribute('download', receipt + '-design.jpg');
        ck.checked = false; send.disabled = true;
        ck.onchange = function () { send.disabled = !ck.checked; };
        send.onclick = function () {
          if (myGen !== gen || !ck.checked) { return; }
          send.disabled = true;
          try { sessionStorage.setItem('wain99_label_mail', '1'); } catch (e) {}
          saveLast(receipt, true);
          hideMailStep();
          finish(receipt, null, '(images will be sent by email: ' + receipt + '-design.jpg + original)');
        };
        $(ms, '[data-lb-ms-back]').onclick = function () { gen += 1; hideMailStep(); reset(); };
        if (btn) { btn.hidden = true; }
        lockForm(true);
        ms.hidden = false;
        ms.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      form.addEventListener('submit', function (e) {
        if (form.getAttribute('data-lb-ready') === '1') { e.preventDefault(); e.stopImmediatePropagation(); return; }
        e.preventDefault();
        /* Shopify の submit handler より前で準備処理を止める。
           preventDefault だけでは CAPTCHA 側の handler が送信を進めてしまう。 */
        e.stopImmediatePropagation();
        fwarn.hidden = true;
        if (!st.img && !(noimg && noimg.checked)) {
          fwarn.textContent = TXT.need_image; fwarn.hidden = false;
          document.getElementById('W99LabelEditor').scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        /* 出どころの申告：「画像なし」を選んだら画像は送らない／許可・素材なら内容が必須 */
        var wantNoImage = !!(noimg && noimg.checked);
        if (wantNoImage && og) { og.value = og.querySelector('[data-k=none]').value; }
        if (!wantNoImage && st.img && originKind() === 'none') { og.value = ''; }
        syncOrigin();
        if (!form.reportValidity()) { return; }
        var receipt = makeReceipt();
        gen += 1; var myGen = gen;
        snapshot = settings(); formSnap = snapForm();
        if (wantNoImage || !st.img) { snapshot.image = null; try { sessionStorage.removeItem('wain99_label_mail'); } catch (e) {} saveLast(receipt, false); finish(receipt, null, '(no image / design help requested)'); return; }
        if (MAILMODE) {
          /* メール方式：デザイン画像を作って画面に出し、保存の確認が取れてから送信する。画像そのものはこのフォームでは送らない */
          if (btn) { btn.disabled = true; btn.textContent = TXT.sending; }
          lockEditor(true);
          /* 検証・スナップショットを取った時点から最終送信まで、申込フォームを固定する（生成待ちの訂正も防ぐ。第3回 P1-01）。
             失敗・15秒超過・「戻る」はすべて reset() を通り、reset() が固定を解く */
          lockForm(true);
          withTimeout(exportPreview(), 15000).then(function (blob) {
            if (myGen !== gen) { return; }
            if (!blob) { throw new Error('no blob'); }
            showMailStep(receipt, blob, myGen);
          }).catch(function () {
            if (myGen !== gen) { return; }
            gen += 1; reset();
            fwarn.textContent = TXT.save_fail; fwarn.hidden = false;
          });
          return;
        }
        if (btn) { btn.disabled = true; btn.textContent = TXT.sending; }
        lockEditor(true);
        /* 送信全体の上限：90秒で戻らなければ元に戻す（上げた画像は同じファイルなら使い回す） */
        clearTimeout(guardTimer);
        guardTimer = setTimeout(function () { gen += 1; reset(); }, 90000);  /* 期限を過ぎた処理は gen が変わるので使われない */
        /* 使い回しは「同じ画像かつ同じデザイン」のときだけ（プレビューが古くならないように） */
        var key = [st.file && st.file.name, st.file && st.file.size, st.file && st.file.lastModified, JSON.stringify(snapshot)].join('|');
        var up = (uploadedKey === key && uploadedUrls) ? Promise.resolve(uploadedUrls) : uploadImages(receipt);
        up.then(function (urls) {
          if (myGen !== gen) { return; }
          uploadedKey = key; uploadedUrls = urls;
          finish(receipt, urls, urls.cleanupFailed ? '(cart cleanup failed)' : '');
        }).catch(function () {
          if (myGen !== gen) { return; }
          reset();
          if (window.confirm(TXT.upload_fail)) {
            finish(receipt, null, '(upload failed - please ask the customer to email the image)');
          }
        });
      }, true);
    }

    /* 送信後（?contact_posted=true）は受付番号を出す */
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      var no = '', mailed = '';
      try { no = sessionStorage.getItem(RKEY) || ''; mailed = sessionStorage.getItem('wain99_label_mail') || ''; } catch (e) {}
      var last = loadLast();
      if (!no && last) { no = last.no; mailed = last.mail ? '1' : ''; }
      var box = document.querySelector('[data-lb-receipt]');
      if (box) {
        box.querySelector('strong').textContent = no || '—';
        var mailBox = box.querySelector('[data-lb-mail]');
        /* メール方式では、番号が取れなくても送り先の案内は必ず出す（端末の保存が使えない場合に備える） */
        if (mailBox && MAILMODE && TXT.mail_to && (mailed || !no)) {
          var link = mailBox.querySelector('[data-lb-mail-link]');
          if (link) { link.href = 'mailto:' + TXT.mail_to + '?subject=' + encodeURIComponent((no ? '[' + no + '] ' : '') + (TXT.mail_subject || '')); }
          var nr = mailBox.querySelector('[data-lb-noreceipt]'); if (nr) { nr.hidden = !!no; }
          mailBox.hidden = false;
        }
        box.hidden = false;
        try { sessionStorage.removeItem(RKEY); sessionStorage.removeItem(SKEY); sessionStorage.removeItem('wain99_label_base'); sessionStorage.removeItem('wain99_label_mail'); } catch (e) {}
        setTimeout(function () { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
      }
    } else {
      restoreDesign();
    }
    var params = new URLSearchParams(window.location.search);
    var requestedProduct = params.get('product');
    // New product navigation always overrides a profile remembered for a different product.
    if (requestedProduct || params.has('base')) {
      var match = profiles.find(function (p) { return p.product && p.product === requestedProduct; });
      profileID = match ? match.id : '';
    }
    profileUI();
    if (profiles.length && (requestedProduct || params.has('base')) && !activeProfile() && profileStatus) {
      profileStatus.textContent = profileStatus.getAttribute('data-unmatched'); profileStatus.hidden = false;
    }
    cleanupCart();
    /* 商品ページの「オリジナルラベル作ってみませんか？」から来たときは銘柄を入れておく */
    var base = new URLSearchParams(window.location.search).get('base');
    var baseEl = document.querySelector('[data-lb-base]');
    try {
      if (base) { sessionStorage.setItem('wain99_label_base', base.slice(0, 120)); }
      else { base = sessionStorage.getItem('wain99_label_base') || ''; }
    } catch (e) {}
    if (baseEl && base && !baseEl.value) { baseEl.value = base.slice(0, 120); }
    render();
  }

  function boot() { document.querySelectorAll('[data-w99-label]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
